module.exports = __webpack_public_path__ + "img/bannerTRE.a99b8811.png";